import { apiConfig } from "./api";
import { firebaseConfig } from "./firebase";

export const config = {
  baseAPIUrl: apiConfig.BASE_API,
  firebase: firebaseConfig,
  vercelPreviewAuthDomain: import.meta.env.VITE_VERCEL_PREVIEW_AUTH_DOMAIN || "https://staging.rebuild.work",
};
